import {useMachineForm} from '../core/MachineProvider'
import {KTIcon} from '../../../_metronic/helpers'
import {MachineProductsRequest} from '../../../coreGlobal/models/products/product'
import {ProductSelect} from '../../../components/ProductSelect'

export const ProductRepeaterForm = ({formik}) => {
  const {products} = useMachineForm()
  const rows: MachineProductsRequest[] = formik.values.products

  const removeRow = (index: number) => {
    formik.setFieldValue(
      'products',
      rows.filter((_, i) => i !== index)
    )
  }

  const rowError = (index: number, field: keyof MachineProductsRequest) => {
    const touched = formik.touched.products?.[index]?.[field]
    const error = formik.errors.products?.[index]?.[field]
    return touched && error ? error : undefined
  }

  return (
    <div className='table-responsive'>
      <table className='table align-middle table-row-dashed fs-6 gy-3'>
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className='min-w-250px'>Produto</th>
            <th className='min-w-150px'>Tempo de sessão (min)</th>
            <th className='w-50px'></th>
          </tr>
        </thead>
        <tbody className='text-gray-700 fw-semibold'>
          {rows.map((row, index) => {
            const selectedElsewhere = rows
              .filter((_, i) => i !== index)
              .map((other) => String(other.product))
            const options = products?.filter(
              (product) => !selectedElsewhere.includes(String(product.value))
            )
            const productValue = products?.find((product) => product.value == row.product) ?? null
            const productError = rowError(index, 'product')
            const sessionTimeError = rowError(index, 'sessionTime')

            return (
              <tr key={index}>
                <td>
                  <ProductSelect
                    inputId={`products${index}`}
                    onChange={(option) => {
                      formik.setFieldValue(`products[${index}].product`, String(option?.value))
                      if (option?.session_time) {
                        formik.setFieldValue(
                          `products[${index}].sessionTime`,
                          String(option.session_time)
                        )
                      }
                    }}
                    onBlur={() => formik.setFieldTouched(`products[${index}].product`, true)}
                    options={options}
                    value={productValue}
                  />
                  {productError && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{productError}</div>
                    </div>
                  )}
                </td>
                <td>
                  <input
                    type='number'
                    min={1}
                    max={32767}
                    step={1}
                    className={`form-control form-control-solid w-150px ${
                      sessionTimeError ? 'is-invalid' : ''
                    }`}
                    {...formik.getFieldProps(`products[${index}].sessionTime`)}
                  />
                  {sessionTimeError && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{sessionTimeError}</div>
                    </div>
                  )}
                </td>
                <td className='text-end'>
                  {rows.length > 1 && (
                    <button
                      type='button'
                      onClick={() => removeRow(index)}
                      className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                    >
                      <KTIcon iconName='trash' className='fs-3' />
                    </button>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
